export const sortByProperty = (property: string) => {
  let sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substring(1);
  }
  return function (a, b) {
    const result = a[property] > b[property] ? -1 : a[property] < b[property] ? 1 : 0;
    return result * sortOrder;
  };
};

export const haveDifferencesBetweenTwoArrays = (firstArray: any[], secondArray: any[]): boolean => {
  if (firstArray.length !== secondArray.length) {
    return true;
  } else if (firstArray.length === 0) {
    return false;
  }
  const diff = firstArray.filter((firstArrayItem) => !secondArray.includes(firstArrayItem)) ?? [];
  return diff?.length > 0;
};
